export { default } from './PagedTemplatePreview';
